// extracted by mini-css-extract-plugin
export default {"tag":"role-tag_tag__cdgTQ"};